module.exports = __webpack_public_path__ + "static/media/PGS.5889ff3d.png";